import { useEffect, useState } from "react";
import { resolveAgentIconUrl } from "../services/agentIconUpload";

export function useAgentIconUrl(iconS3Key?: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!iconS3Key?.trim()) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    void (async () => {
      try {
        const res = await resolveAgentIconUrl(iconS3Key);
        if (!cancelled) setUrl(res.publicUrl || res.url);
      } catch {
        if (!cancelled) setUrl(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [iconS3Key]);

  return url;
}
